// Hover Dropdown Menu
const hoverNav = document.querySelectorAll(".hover_navigation");
hoverNav.forEach((e) => {
  e.addEventListener("mouseover", () => {
    e.setAttribute("open", "open");
  });
  e.addEventListener("mouseout", () => {
    e.removeAttribute("open");
  });
});

// login register recovery
    $(document).ready(function(){
        $(".eyeButton").click(function () {
          $(this).toggleClass("hidden1");
          var input = $('#CustomerPassword'); // Corrected selector
          console.log("CustomerPasswordeye>>>>>>", input.attr("type"));
          if (input.attr("type") == "password") {
            input.attr("type", "text");
          } else {
            input.attr("type", "password");
          }
        });
      
          $("span.register_btn.eyeButton").click(function () {
          $(this).toggleClass("hidden2");
          var inputs = $('#RegisterForm-password'); // Corrected selector
          console.log("CustomerPasswordeye>>>>>>", inputs.attr("type"));
          if(inputs.attr("type") == "password") {
            inputs.attr("type", "text");
          } else {
            inputs.attr("type", "password");
          }
        });

        $('.account_register_url.customer.button').click(function () {
        window.location.href = '/account/register';
        });
        $('.account_register_url.customer.button.custom_rig').click(function () {
        window.location.href = '/account/login';
        });
      })
    $('.brand .multicolumn-list').slick({
		rows: 3,
		dots: false,
		arrows: true,
		infinite: true,
		speed: 300,
		slidesToShow: 5,
		slidesToScroll: 5,
      responsive: true,
      responsive: [
     {
     breakpoint: 767,
     settings: {
       rows: 1,
       slidesPerRow: 1,
       slidesToShow: 2,
		slidesToScroll: 1,
     }
    }
  ] 
});



$(document).ready(function () {
  $('.product-form__input.custom_var_1 input').click(function () {
    console.log("Hello");
    var instock = $(this).attr('data-available');
    console.log("instock", instock);
    if (instock === "true") {
      $('#BIS_trigger').hide();
      $('.product-form__buttons.cstm_notify_me').show();
    } else {
      $('#BIS_trigger').css("display", "block !important");
      $('.product-form__buttons.cstm_notify_me').hide();
    }
  });
});


